import React, { Component } from "react";
import logo from "../../../assets/img/brand/veridaLogo.svg";
import "./Oops.scss";

class Oops extends Component {
  render() {
    return (
      <div className="main-wrapper">
        <div className="container h-100">
          <div className="row align-items-center h-100">
            <div className="col-6 mx-auto">
              <div className="jumbotron text-center">
                <img
                  src={logo}
                  className="logo img-fluid"
                  alt="Verida"
                />
                <i class="fa fa-ambulance large m-4"></i>
                <h2>Pardon the Interruption:</h2>
                <p>{this.props.message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Oops;
